import React, { useEffect, useState } from "react";
import { I18n } from "react-polyglot";

import getPOEditorLocalization from "./getPOEditorLocalization";

import * as languages from "../../localisation";
import config from "../../config";

const I18nHOC = ({ children }) => {
  const localLocale = config.localisation.default;

  const [locale, setLocale] = useState(localLocale);
  const [messages, setMessages] = useState({});

  useEffect(() => {
    async function setLocalization() {
      try {
        const { POEditor } = config;

        const localisation = await getPOEditorLocalization(
          POEditor.projectName,
          POEditor.defaultLocale
        );

        setLocale(POEditor.defaultLocale);
        setMessages(localisation);
      } catch (error) {
        const localLocale = config.localisation.default;
        const localisation = languages[localLocale];

        setMessages(localisation);
      }
    }

    setLocalization();
  }, []);

  return (
    <>
      {Object.prototype.hasOwnProperty.call(messages, "header") ? (
        <I18n locale={locale} messages={messages}>
          {children}
        </I18n>
      ) : (
        <>{null}</>
      )}
    </>
  );
};

export { I18nHOC };



// WEBPACK FOOTER //
// ./src/js/hocs/I18n/index.js